import React, { useState, useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { SelectBox } from "devextreme-react";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import TransactionEntryGrid from "./TransactionEntryGrid";
import { formatMessage } from 'devextreme/localization';
import '../../common/css/searchPage.css';
// localStorage key holding the last Warehouse / Location / Item search, so returning from the
// Inventory Operation page restores it.
const TRANSACTION_FILTERS_KEY = "transactionFilters";

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
function TransactionEntryForm(props) {
    var accessToken = props.oidc.user.access_token;
    const [dateSourceWarehouse, setDateSourceWarehouse] = useState(null);
    const [warehouseData, setWarehouseData] = useState(null);
    const [dateSourceLocation, setDateSourceLocation] = useState(null);
    const [inventoryItemCodesData, setinventoryItemCodesData] = useState([]);
    const [formSubmitted, setformSubmitted] = useState(false);
    const [locationData, setLocationData] = useState(null);
    const [itemData, setItemData] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);
    var url = "im/Transactionlocation/GetTransactionSummarylocationDetails";
    const loadInventoryItemData = () => {
        var apiMethod = "im/Lookup/GetItems";
        const resultData = createStore({
            key: 'id',
            loadParams:
            {

            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        setinventoryItemCodesData(resultData)
    };
    const dataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams: {
            warehouseId: function () {
                return warehouseData;
            },
            locationId: function () {
                // Send empty (not JS null) so it isn't serialized as the literal string "null".
                return locationData || '';
            },
            itemid: function () {
                return itemData;
            }
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        },

    }), [formSubmitted]);
    const loadWarehouseData = useCallback(() => {
        var dataSourceDB = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        setDateSourceWarehouse(dataSourceDB);
    }, []);
    const loadLocationData = useCallback((value) => {
        var dataSourceDB = new DataSource({
            store: new createStore({
                key: 'id',
                loadParams: {
                    warehouseRowId: function () {
                        return value;
                    },
                    module: function () {
                        return 'IM';
                    }
                },
                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        setDateSourceLocation(dataSourceDB);
    }, []);
    const selectionChanged = useCallback(
        (e, tg) => {

            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const onSearchTransaction = async (e) => {
        e.preventDefault();
    };
    const handelSearch = (e) => {
        e.event.stopPropagation();
        
        localStorage.setItem(TRANSACTION_FILTERS_KEY, JSON.stringify({
            warehouseId: warehouseData,
            locationId: locationData,
            itemId: itemData
        }));
        setformSubmitted((prevStatus) => {
            const newStatus = !prevStatus;
            return newStatus;
        });
    }
    // Clears all search filters and any persisted filter state. Used by the Reset button.
    const resetFilters = useCallback(() => {
        setWarehouseData('');
        setLocationData('');
        setItemData('');
        localStorage.removeItem(TRANSACTION_FILTERS_KEY);
    }, []);

    // Reapplies the filter saved by the last Search, if any. Called on mount.
    const restoreSavedFilters = useCallback(() => {
        let saved = null;
        try {
            const raw = localStorage.getItem(TRANSACTION_FILTERS_KEY);
            saved = raw ? JSON.parse(raw) : null;
        } catch (error) {
            // Corrupt entry (hand-edited, or written by an older shape): drop it and start clean
            // rather than leaving the screen stuck on an unparseable filter.
            localStorage.removeItem(TRANSACTION_FILTERS_KEY);
            return;
        }

        if (!saved) return;

        const { warehouseId, locationId, itemId } = saved;
        if (!warehouseId && !locationId && !itemId) return;

        setWarehouseData(warehouseId || '');
        setItemData(itemId || '');

        if (warehouseId) {
            // Rebuild the location list for the saved warehouse before selecting within it.
            loadLocationData(warehouseId);
        }

        // Apply the location once the new location store is in place, then run the search.
        Promise.resolve().then(() => {
            setLocationData(locationId || '');
            setformSubmitted((prev) => !prev);
        });
    }, [loadLocationData]);
    const handelReset = (e) => {
        try {
            e.event.stopPropagation();
            resetFilters();
        }
        catch (error) {
        }
        finally {
        }
    }
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 768);
    };
    useEffect(() => {
        loadWarehouseData();
        loadInventoryItemData();
        updateView();
        window.addEventListener("resize", updateView);

        // Restore the last search so a round-trip to the Inventory Operation page and back keeps the
        // Warehouse / Location / Item the user had searched on, and re-runs that search.
        //
        // The location list is scoped to the chosen warehouse, so its store has to be rebuilt for the
        // saved warehouse before the saved location can be selected. loadLocationData only swaps the
        // DataSource (no awaitable load), so the location is applied on the next tick rather than in
        // this one — the SelectBox needs its store replaced first or it discards the value as not in
        // its list. Toggling formSubmitted last re-runs the grid query with all three filters.
        restoreSavedFilters();

        return () => {
            window.removeEventListener("resize", updateView);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = useCallback((e) => {
        setWarehouseData(e.value);
        setLocationData('');
        loadLocationData(e.value);
    }, [warehouseData]);
    const handleChangeLocation = useCallback((e) => {
        setLocationData(e.value);
    }, []);
    // Allow searching by free-typed text: when the entered text isn't an existing location,
    // keep it as the value so the backend can run a LIKE search on the location code.
    const handleCustomLocation = useCallback((e) => {
        const text = (e.text || '').trim();
        if (!text) {
            e.customItem = null;
            return;
        }
        e.customItem = { id: text, name: text };
    }, []);
    const handleChangeItem = useCallback((e) => {
        setItemData(e.value);
    }, []);
    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <form onSubmit={(e) => onSearchTransaction(e)}>
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before" >
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2
                                                }}
                                            >
                                                {formatMessage('Title')}
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after" visible={!isMobileView}>
                                        <Button className="accordianButton" onClick={handelSearch} text={formatMessage('Search')} type="default" />
                                    </Item>
                                    <Item location="after" visible={!isMobileView}>
                                        <Button className="accordianButton" onClick={handelReset} text={formatMessage('Reset')} />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={dateSourceWarehouse}
                                                value={warehouseData}
                                                searchEnabled={true}
                                                searchMode="contains"
                                                onValueChanged={(e) => handleChange(e)}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={formatMessage('ChooseSite')}
                                                displayExpr="name"
                                                valueExpr="id"
                                            >
                                            </SelectBox>
                                        </div>
                                        <div className="col-md-12 accordianLastRow">
                                            <SelectBox
                                                dataSource={dateSourceLocation}
                                                value={locationData}
                                                searchEnabled={true}
                                                searchMode="contains"
                                                acceptCustomValue={true}
                                                onCustomItemCreating={handleCustomLocation}
                                                onValueChanged={(e) => handleChangeLocation(e)}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={formatMessage('ChooseLocation')}
                                                displayExpr="name"
                                                valueExpr="id"
                                            >
                                            </SelectBox>
                                        </div>
                                        <div className="col-md-12 accordianLastRow">
                                            <SelectBox
                                                dataSource={inventoryItemCodesData}
                                                value={itemData}
                                                searchEnabled={true}
                                                searchMode="contains"
                                                onValueChanged={(e) => handleChangeItem(e)}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={formatMessage('Item')}
                                                displayExpr="name"
                                                valueExpr="id"
                                            >
                                            </SelectBox>
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow" visible={isMobileView}>
                                        <div className="col-md-12">
                                            <Button className="accordianButton" onClick={handelSearch} visible={isMobileView} text={formatMessage('Search')} type="default" />
                                            <Button className="accordianButton" onClick={handelReset} visible={isMobileView} text={formatMessage('Reset')} />
                                        </div>
                                    </div>
                                </div>
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                    </form>
                </div>
                <div className="search-page-grid-container">
                    <TransactionEntryGrid searchPanelStatus={searchPanelStatus} dataSource={dataSource}></TransactionEntryGrid>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionEntryForm);